import api from './api';

const goodsReceiptNoteService = {
  // Get all GRNs
  getAllGRNs: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.supplier) queryParams.append('supplier', params.supplier);
      if (params.purchaseOrder) queryParams.append('purchaseOrder', params.purchaseOrder);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/goods-receipt-note${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching GRNs:', error);
      throw error;
    }
  },

  // Get GRN by ID
  getGRNById: async (id) => {
    try {
      const response = await api.get(`/goods-receipt-note/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching GRN:', error);
      throw error;
    }
  },

  // Get next GRN number
  getNextGRNNumber: async () => {
    try {
      const response = await api.get('/goods-receipt-note/number/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next GRN number:', error);
      throw error;
    }
  },

  // Get purchase order details for GRN creation
  getPurchaseOrderForGRN: async (purchaseOrderId) => {
    try {
      const response = await api.get(`/goods-receipt-note/purchase-order/${purchaseOrderId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching purchase order for GRN:', error);
      throw error;
    }
  },

  // Create GRN
  createGRN: async (grnData) => {
    try {
      const response = await api.post('/goods-receipt-note', grnData);
      return response.data;
    } catch (error) {
      console.error('Error creating GRN:', error);
      throw error;
    }
  },

  // Update GRN
  updateGRN: async (id, grnData) => {
    try {
      const response = await api.put(`/goods-receipt-note/${id}`, grnData);
      return response.data;
    } catch (error) {
      console.error('Error updating GRN:', error);
      throw error;
    }
  },

  // Delete GRN
  deleteGRN: async (id) => {
    try {
      const response = await api.delete(`/goods-receipt-note/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting GRN:', error);
      throw error;
    }
  },

  // Accept GRN
  acceptGRN: async (id) => {
    try {
      const response = await api.put(`/goods-receipt-note/${id}/accept`);
      return response.data;
    } catch (error) {
      console.error('Error accepting GRN:', error);
      throw error;
    }
  },

  // Get GRN statistics
  getGRNStats: async () => {
    try {
      const response = await api.get('/goods-receipt-note/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching GRN statistics:', error);
      throw error;
    }
  }
};

export default goodsReceiptNoteService;

